export const BINARY = 'binary';
export const POINTS = 'points';

export const TEXT = 'text';
export const PICS = 'pics';
export const SHORT = 'short';
